import { useState, useEffect, useRef, useCallback } from 'react';
import { SessionStateDTO, getSessionState } from '../services/studentSessionService';

const POLL_INTERVAL_MS = 15_000;

export function useSessionState(courseId: number) {
  const [sessionState, setSessionState] = useState<SessionStateDTO | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const lastSeqRef = useRef<number | undefined>(undefined);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const poll = useCallback(async () => {
    try {
      const state = await getSessionState(courseId, lastSeqRef.current);
      if (state !== null) {
        lastSeqRef.current = state.lastSeq;
        setSessionState(state);
      }
      setError(null);
    } catch (err: any) {
      if (err?.response?.status === 403) {
        setError('You are not enrolled in this course');
        return;
      }
      // Transient errors — keep previous state
    } finally {
      setLoading(false);
    }
  }, [courseId]);

  useEffect(() => {
    poll();
    intervalRef.current = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [poll]);

  return { sessionState, loading, error };
}
